import { Component, Input, OnInit } from '@angular/core';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { PrequalAppScoring } from '@app/models';
import { NgClass } from '@angular/common';

@Component({
  selector: 'qb-prequal-app-scoring',
  templateUrl: './prequal-app-scoring.component.html',
  styleUrls: ['./prequal-app-scoring.component.scss'],
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgClass,
  ],
})
export class PrequalAppScoringComponent implements OnInit {
  @Input() scores: PrequalAppScoring[];
  @Input() displayMinimumToPass: boolean = false;

  scoreColumnsToDisplay: string[] = ['sections', 'actual', 'possible', 'percent'];
  scoreDataSource: MatTableDataSource<PrequalAppScoring>;
  // scores: QbatPrequalAppScoring[] = [];
  isPassing: boolean = false;
  isPassingString = '* Minimum to Pass ';

  constructor() {}

  ngOnInit(): void {
    if (!this.scores) {
      return;
    }

    const total = this.scores.find(val => {
      return val.section == 'Total';
    });

    if (total) {
      const passingScore = total.possible * 0.75;
      this.isPassingString += Math.ceil(passingScore) + '/' + total.possible + ' (75%)';
      this.isPassing = total.actual > passingScore;
      total.percent = ((total.actual / total.possible) * 100).toFixed(2).toString() + '%';

      this.scoreDataSource = new MatTableDataSource(this.scores);
    } else {
      this.scoreDataSource = new MatTableDataSource([]);
    }
  }
}
